import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/** Consistent "back to Toolkit hub" control for every SC Toolkit sub-page. */
export default function ScToolkitBack({ label = "Toolkit" }) {
  return (
    <Link
      to="/sc/marketing"
      data-testid="sc-toolkit-back-btn"
      className="mb-3 -mt-1 inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-[#1B5E20] hover:text-[#15501A] active:scale-95 transition-transform"
    >
      <ArrowLeft className="w-3.5 h-3.5" /> {label}
    </Link>
  );
}
